import React, { useState, useEffect } from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    Input,
    Select,
    Button,
    VStack,
    HStack,
    SimpleGrid,
    Text,
    Box,
} from "@chakra-ui/react";

const GameModal = ({ isOpen, onClose, editData, onSave }) => {
    const [formData, setFormData] = useState({
        eventType: "",
        league: "",
        title: "",
        gameStartsFrom: "",
        betStartsFrom: "",
        slug: "",
    });

    useEffect(() => {
        if (editData) {
            setFormData({
                eventType: editData.category || "",
                league: editData.league || "",
                title: editData.title || "",
                gameStartsFrom: editData.gameStart || "",
                betStartsFrom: editData.betStart || "",
                slug: editData.slug || "",
            });
        } else {
            setFormData({
                eventType: "",
                league: "",
                title: "",
                gameStartsFrom: "",
                betStartsFrom: "",
                slug: "",
            });
        }
    }, [editData, isOpen]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = () => {
        onSave(formData);
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size={{ base: "full", md: "3xl" }} scrollBehavior="inside" isCentered>
            <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(2px)" />
            <ModalContent borderRadius={{ base: 0, md: "xl" }} p={{ base: 0, md: 4 }} mx={{ base: 0, md: 4 }}>
                <ModalHeader fontSize="xl" fontWeight="600" color="#2d3748">
                    {editData ? "Edit Game" : "Add New Game"}
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody p={0}>
                    <VStack spacing={5} align="stretch" mt={0}>
                        <Box bg="white" p={{ base: 4, md: 6 }} borderRadius={{ base: 0, md: "lg" }} border={{ base: "none", md: "1px solid" }} borderColor="gray.100" boxShadow="sm">
                            <VStack spacing={4} align="stretch">
                                <FormControl isRequired>
                                    <FormLabel fontWeight="600" fontSize="sm" color="gray.700">
                                        Event Type <Text as="span" color="red.500">*</Text>
                                    </FormLabel>
                                    <Select
                                        placeholder="Select One"
                                        name="eventType"
                                        value={formData.eventType}
                                        onChange={handleChange}
                                        h="50px"
                                        borderColor="gray.300"
                                        _focus={{ borderColor: "indigo.500", boxShadow: "0 0 0 1px #4f46e5" }}
                                    >
                                        <option value="Mixed Martial Arts">Mixed Martial Arts</option>
                                        <option value="Soccer">Soccer</option>
                                        <option value="Cricket">Cricket</option>
                                    </Select>
                                </FormControl>

                                <FormControl isRequired>
                                    <FormLabel fontWeight="600" fontSize="sm" color="gray.700">
                                        League <Text as="span" color="red.500">*</Text>
                                    </FormLabel>
                                    <Select
                                        placeholder="Select One"
                                        name="league"
                                        value={formData.league}
                                        onChange={handleChange}
                                        h="50px"
                                        borderColor="gray.300"
                                        _focus={{ borderColor: "indigo.500", boxShadow: "0 0 0 1px #4f46e5" }}
                                    >
                                        <option value="MMA">MMA</option>
                                        <option value="Ligue 2 – France">Ligue 2 – France</option>
                                    </Select>
                                </FormControl>

                                <FormControl isRequired>
                                    <FormLabel fontWeight="600" fontSize="sm" color="gray.700">
                                        Title <Text as="span" color="red.500">*</Text>
                                    </FormLabel>
                                    <Input
                                        name="title"
                                        value={formData.title}
                                        onChange={handleChange}
                                        placeholder="Enter Title"
                                        h="50px"
                                        borderColor="gray.300"
                                        _focus={{ borderColor: "indigo.500", boxShadow: "0 0 0 1px #4f46e5" }}
                                    />
                                </FormControl>

                                <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                                    <FormControl isRequired>
                                        <FormLabel fontWeight="600" fontSize="sm" color="gray.700">
                                            Game Starts From <Text as="span" color="red.500">*</Text>
                                        </FormLabel>
                                        <Input
                                            type="datetime-local"
                                            name="gameStartsFrom"
                                            value={formData.gameStartsFrom}
                                            onChange={handleChange}
                                            h="50px"
                                            borderColor="gray.300"
                                            _focus={{ borderColor: "indigo.500", boxShadow: "0 0 0 1px #4f46e5" }}
                                        />
                                    </FormControl>

                                    <FormControl isRequired>
                                        <FormLabel fontWeight="600" fontSize="sm" color="gray.700">
                                            Bet Starts From <Text as="span" color="red.500">*</Text>
                                        </FormLabel>
                                        <Input
                                            type="datetime-local"
                                            name="betStartsFrom"
                                            value={formData.betStartsFrom}
                                            onChange={handleChange}
                                            h="50px"
                                            borderColor="gray.300"
                                            _focus={{ borderColor: "indigo.500", boxShadow: "0 0 0 1px #4f46e5" }}
                                        />
                                    </FormControl>
                                </SimpleGrid>

                                <FormControl isRequired>
                                    <FormLabel fontWeight="600" fontSize="sm" color="gray.700">
                                        Slug <Text as="span" color="red.500">*</Text>
                                    </FormLabel>
                                    <Input
                                        name="slug"
                                        value={formData.slug}
                                        onChange={handleChange}
                                        placeholder="Enter Slug"
                                        h="50px"
                                        borderColor="gray.300"
                                        _focus={{ borderColor: "indigo.500", boxShadow: "0 0 0 1px #4f46e5" }}
                                    />
                                </FormControl>

                                <Button
                                    colorScheme="indigo"
                                    bg="#4f46e5"
                                    color="white"
                                    w="100%"
                                    h="50px"
                                    fontSize="md"
                                    fontWeight="bold"
                                    _hover={{ bg: "#4338ca" }}
                                    onClick={handleSubmit}
                                    mt={2}
                                >
                                    Submit
                                </Button>
                            </VStack>
                        </Box>
                    </VStack>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default GameModal;
